<template>
    <div class="courses-area pt-100 pb-70"  id="kurslarimiz">
        <div class="container">
            <!-- <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2 class="font-weight-black">{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div> -->
            <div class="courses-slides-two">
                <carousel
                    :autoplay="5000"
                    :settings='settings' 
                    :breakpoints='breakpoints'
                    :wrap-around="true"
                >
                    <Slide v-for="course in courses" :key="course.course_id">
                        <div class="single-kindergarten-courses-box">
                            <div class="courses-image">
                                <div class="image">
                                    <img :src="getImgUrl('kurslar', course.course_img)" alt="image">
                                </div>
                                <div class="price">
                                    <img src="../../../../assets/resimler/resimler/price-bg.png" alt="image">
                                    <span>₺{{course.course_price}}</span>
                                </div>
                                <a href="#" class="link-btn"></a>
                            </div>
                            <div class="courses-content">
                                <div class="course-author d-flex align-items-center">
                                    <img :src="getImgUrl('ogretmenler', course.course_teacher_img)" class="rounded-circle" alt="image">
                                    <span>{{course.course_teacher}}</span>
                                </div>
                                <h3 class="font-weight-black">
                                    <div>
                                        {{course.course_header}}
                                    </div>
                                </h3>
                                <p>{{course.course_content}}</p>
                            </div>
                        </div>
                    </Slide>
                    
                    <template #addons>
                        <Navigation />
                    </template>
                </carousel>
            </div>
        </div>
        <div class="kindergarten-shape11">
            <img src="../../assets/img/kindergarten-shape/k-shape11.png" alt="image">
        </div>
        <div class="kindergarten-shape12">
            <img src="../../assets/img/kindergarten-shape/k-shape12.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";


import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'CoursesList',
    props: ['pathUrl'],
    
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    data: () => ({
        titles: [],
        courses: [{"course_id":1,"course_img":"the-unit-circle-definition-of-sine-and-cosine.jpeg","course_teacher":"Ali Veli","course_teacher_img":"ali-veli.jpeg","course_price":111,"course_header":"Piyano Kursu","course_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore."}],
        errors: [],

        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
			},
            576: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 2,
                snapAlign: 'left',
            },
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
        },
        
    }),
    created() {
        this.getTitles();
        this.getAllCourses();
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=5")
                .then(response => (this.titles = response.data.result))
                    .catch(error => {
                        this.errors.push(error);
                    });
        },
        getAllCourses() {
            axios.get(this.pathUrl + "?data=courses")
                .then(response => (this.courses = response.data.result))
                    .catch(error => {
                        this.errors.push(error);
                    });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/'+ category +'/'+ pet)
        }
    },

    

})
</script>